import { format, unwrapFunctionStore } from 'svelte-i18n';

import { typeCharacters } from '@client/utils/dom';

import { GLOBAL_DRIVER_OBJECT } from '@client/enums';

const $format = unwrapFunctionStore(format);

export const adModal = {
  element: '.modal-content',
  popover: {
    title: 'Ad Details',
    description:
      "Enter your ad details and choose from any customizations you need. When you're done, click <strong>&quot;Next <i class='os-icon-arrow-right'></i> Targeting&quot;</strong> to define your audience.",
    side: 'right',
    align: 'center',
    onPrevClick: () => {
      const backButton = document.querySelector('.back');

      if (backButton) {
        backButton.click();

        setTimeout(() => {
          GLOBAL_DRIVER_OBJECT.movePrevious();
        }, 200);
      }
    }
  }
};

export const adModalClickAction = {
  element: 'div.modal-body > div > div > div:nth-child(1)',
  popover: {
    title: 'Click Action',
    description:
      'Decide where recipients go when they click your ad banner—a <strong>URL</strong>, <strong>document</strong>, or <strong>video</strong>.',
    side: 'right',
    align: 'center',
    onPopoverRender: () => {
      const actionButtons = document.querySelectorAll(
        'div.modal-body > div > div > div:nth-child(1) > div.campaign-actions.click-action > div'
      );

      const urlInput = document.querySelector(
        'div.modal-body > div > div > div:nth-child(1) > div.campaign-actions.click-action > input'
      );

      const popoverNavBtns = document.querySelectorAll(
        '#driver-popover-content > footer > span.driver-popover-navigation-btns'
      );

      if (popoverNavBtns && urlInput && urlInput.value === '') {
        popoverNavBtns[0].children[0].disabled = true;
        popoverNavBtns[0].children[0].classList.add('driver-popover-btn-disabled');
        popoverNavBtns[0].children[1].disabled = true;
        popoverNavBtns[0].children[1].classList.add('driver-popover-btn-disabled');
      }

      if (actionButtons && urlInput && urlInput.value === '') {
        setTimeout(() => {
          actionButtons[0].children[1].click();
        }, 700);

        setTimeout(() => {
          actionButtons[0].children[2].click();
        }, 1400);

        setTimeout(() => {
          actionButtons[0].children[0].click();
        }, 2100);

        setTimeout(() => {
          const urlInput = document.querySelector(
            'div.modal-body > div > div > div:nth-child(1) > div.campaign-actions.click-action > input'
          );

          typeCharacters(urlInput, 'https://www.opensense.com', 75);
        }, 2300);

        setTimeout(() => {
          popoverNavBtns[0].children[0].disabled = false;
          popoverNavBtns[0].children[0].classList.remove('driver-popover-btn-disabled');
          popoverNavBtns[0].children[1].disabled = false;
          popoverNavBtns[0].children[1].classList.remove('driver-popover-btn-disabled');
        }, 4200);
      }
    }
  }
};

export const adModalUTM = {
  element: 'div.modal-body > div > div > div:nth-child(2)',
  popover: {
    title: 'UTM Parameters',
    description:
      'If you select <strong>URL</strong>, an option to add <strong>UTM Parameters</strong> will appear. Click the <strong>&quot;<i class="os-icon-plus"></i> Param&quot;</strong> button to add a new UTM parameter to your ad.',
    side: 'right',
    align: 'center',
    onPopoverRender: () => {
      const addParamBtn = document.querySelector(
        'div.modal-body > div > div > div:nth-child(2) > div.campaign-actions > div > button'
      );

      const nameInput = document.querySelector(
        'div.modal-body > div > div > div:nth-child(2) > div.campaign-actions > div > div > input.name'
      );

      if (addParamBtn && !nameInput) {
        addParamBtn.click();
      }

      setTimeout(() => {
        const nameInput = document.querySelector(
          'div.modal-body > div > div > div:nth-child(2) > div.campaign-actions > div > div > input.name'
        );

        if (nameInput && nameInput.value === '') {
          typeCharacters(nameInput, 'tour', 75);
        }
      }, 150);

      setTimeout(() => {
        const valueInput = document.querySelector(
          'div.modal-body > div > div > div:nth-child(2) > div.campaign-actions > div > div > input.value'
        );

        if (valueInput && valueInput.value === '') {
          typeCharacters(valueInput, 'tour_value', 75);
        }
      }, 450);
    },
    onPrevClick: () => {
      const trashBtn = document.querySelector(
        'div.modal-body > div > div > div:nth-child(2) > div.campaign-actions > div > div > i'
      );

      if (trashBtn) {
        trashBtn.click();

        GLOBAL_DRIVER_OBJECT.movePrevious();
      }
    }
  }
};

export const adModalUTMRemove = {
  element: 'div.modal-body > div > div > div:nth-child(2) > div.campaign-actions > div > div > i',
  popover: {
    title: 'Remove UTM Parameter',
    description: 'Click the <code><i class="os-icon-trash"></i></code> icon to remove a UTM parameter from your URL.',
    side: 'top',
    align: 'center'
  }
};

export const adModalTypeText = {
  element: 'div.modal-body > div > div > div:nth-child(3)',
  popover: {
    title: 'Text Ad',
    description: `
      Select <strong>Text</strong> to add custom messaging to your ad.
      <br/><br/>
      <strong>Options</strong> 
      <br/>
      <ul>
        <li><strong>Allow Internal</strong> - Track internal impressions and clicks.</li>
        <li><strong>Disable Tracking</strong> - Turn off view beacons for this ad.</li>
      </ul>
      `,
    side: 'right',
    align: 'center',
    onPopoverRender: () => {
      const textInput = document.querySelector(
        'div.modal-body > div > div > div:nth-child(3) > div.campaign-actions.ad > div.text-ad > input:nth-child(1)'
      );

      if (textInput && textInput.value === '') {
        typeCharacters(textInput, 'This is a tour campaign', 75);
      }
    },
    onNextClick: () => {
      const adTypeImageBtn = document.querySelector(
        'div.modal-body > div > div > div:nth-child(3) > div.campaign-actions.ad > div.btn-group > button:nth-child(2)'
      );

      if (adTypeImageBtn) {
        adTypeImageBtn.click();

        setTimeout(() => {
          GLOBAL_DRIVER_OBJECT.moveNext();
        }, 200);
      }
    }
  }
};

export const adModalTypeImage = {
  element: 'div.modal-body > div > div > div:nth-child(3)',
  popover: {
    title: 'Image Ad',
    description: `
      Select <strong>Image</strong> to upload a custom ad creative. For best results, use images that are <strong>580x150</strong> and less than <strong>150kb</strong>. 
      <br/><br/>
      <strong>Options</strong>
      <br/> 
      <ul>
        <li><strong>Inline Image</strong> - Ensures deliverability by embedding the image directly.</li>
        <li><strong>High-Resolution Image (2x)</strong> - Enables sharper rendering for high-res displays.</li>
        <li><strong>Placeholder Image</strong> - Use this banner as a temporary placeholder during setup.</li>
        <li><strong>Allow Internal</strong> - Tracks internal impressions and clicks.</li>
        <li><strong>Disable Tracking</strong> - Turns off view beacons for this ad.</li>
      </ul>
      `,
    side: 'right',
    align: 'center',
    onPrevClick: () => {
      const adTypeTextBtn = document.querySelector(
        'div.modal-body > div > div > div:nth-child(3) > div.campaign-actions.ad > div.btn-group > button:nth-child(1)'
      );

      if (adTypeTextBtn) {
        adTypeTextBtn.click();

        setTimeout(() => {
          GLOBAL_DRIVER_OBJECT.movePrevious();
        }, 200);
      }
    }
  }
};

export const goToTargetingModal = {
  element: '#modal-next-btn',
  popover: {
    title: 'Next Step',
    description:
      "When you're ready, click <strong>&quot;Next <i class='os-icon-arrow-right'></i> Targeting&quot;</strong> to define your audience.",
    side: 'bottom',
    align: 'center',
    onPopoverRender: () => {
      const adTypeTextBtn = document.querySelector(
        'div.modal-body > div > div > div:nth-child(3) > div.campaign-actions.ad > div.btn-group > button:nth-child(1)'
      );

      if (adTypeTextBtn) {
        adTypeTextBtn.click();

        setTimeout(() => {
          const textInput = document.querySelector(
            'div.modal-body > div > div > div:nth-child(3) > div.campaign-actions.ad > div.text-ad > input:nth-child(1)'
          );

          if (textInput && textInput.value === '') {
            typeCharacters(textInput, 'This is a tour campaign', 75);
          }
        }, 200);
      }
    },
    onPrevClick: () => {
      GLOBAL_DRIVER_OBJECT.moveTo(14);
    },
    onNextClick: () => {
      const nextBtn = document.querySelector('#modal-next-btn');

      if (nextBtn) {
        nextBtn.click();

        setTimeout(() => {
          GLOBAL_DRIVER_OBJECT.moveNext();
        }, 200);
      }
    }
  }
};
